import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { FaMapMarkerAlt, FaPhone, FaLanguage, FaCode, FaShoppingCart, FaBookOpen } from 'react-icons/fa'; // Importing icons
import logo from '../../assets/logo.svg';
import './CustomNavbar.css';
import { Link } from 'react-router-dom';
import { MdOutlineMenuBook } from "react-icons/md";
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';

function CustomNavbar() {
  const [expanded, setExpanded] = useState(false);
  const [searchQuery, setSearchQuery] = useState(''); // Added state for search input
  const { i18n, t } = useTranslation();
  const [checked, setChecked] = useState(i18n.language === 'rs');

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    const newLang = nextChecked ? 'rs' : 'en';
    i18n.changeLanguage(newLang);
  };

  // Fixed the search function to redirect to AG website
  const redirectToAG = () => {
    if (searchQuery.trim()) {
      const encoded = encodeURIComponent(searchQuery);
      // Using the simpler search URL format that should work without cHash issues
      const searchUrl = `https://www.hansa-flex.de/en/search/?tx_indexedsearch_pi2[action]=search&tx_indexedsearch_pi2[controller]=Search&tx_indexedsearch_pi2[search][sword]=${encoded}`;
      window.open(searchUrl, '_blank'); // Open in new tab
    }
  };

  // Handle Enter key press in search input
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      redirectToAG();
    }
  };

  return (
    <div>
      <Navbar className='white-bg margin-left' variant="light" expand="lg" expanded={expanded} >
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}
            className="d-inline-block align-top custom-nav-logo"
            alt="Logo"
          />
        </Navbar.Brand>

        <div className='custom-nav-menu'>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(!expanded)} />
          <div className='left-align-items'>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="c-nav-menu">
                <Nav.Link href="#">
                  <div className='d-flex align-items-center'>
                    <FaLanguage /><span className={`language-label ${!checked ? 'active' : ''}`} style={{ marginRight: '5px' }}>{t("EN")} </span>
                    <Switch
                      checked={checked}
                      onChange={handleChange}
                      onColor="#4CAF50"
                      offColor="#FF5722"
                      onHandleColor="#fff"
                      offHandleColor="#fff"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={22}
                      width={48}
                      className="language-switch"
                    />
                    <span className={`language-label ${checked ? 'active' : ''}`} style={{ marginLeft: '5px' }}> {("RS")} </span>
                  </div>
                </Nav.Link>

                <Nav.Link>
                  <div className="search-container d-flex align-items-center">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onKeyPress={handleKeyPress}
                      placeholder="Search"
                      className="form-control"
                      style={{ width: '200px', padding: '2px', fontSize: '0.9rem', border: '2px solid #30557D', borderRadius: '4px' }}
                    />
                    <div onClick={redirectToAG} className="search-button m-2 d-flex align-items-center" type="button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                      </svg>
                    </div>
                  </div>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>
    </div>
  );
}

export default CustomNavbar;